import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import TaskTemplateIndex from "../../../../../components/taskAdmin/taskTemplates/taskAdminIndex";
import ReassignTasks from "../../../../../components/taskAdmin/reassignTasks";
import TaskTemplate, { getTaskAdminTemplateBaseRoute, } from "./TaskTemplate/AdminTaskTemplateRoutes";
import ActionPlans, { getTaskAdminActionPlanBaseRoute, } from "./ActionPlans/AdminActionPlansRoutes";
// Paths
export const getTaskAdminBasePath = () => `${getAdminBasePath()}/taskAdmin`;
export const getTaskAdminIndexPath = () => `${getTaskAdminBasePath()}/index`;
// reassign tasks paths
export const getTaskAdminReassignTasksPath = () => `${getTaskAdminBasePath()}/reassigntasks`;
// Routes
export const getTaskAdminBaseRoute = () => `${getAdminBaseRoute()}/taskAdmin`;
export const getTaskAdminIndexRoute = () => `${getTaskAdminBaseRoute()}/index`;
// reassign tasks routes
export const getTaskAdminReassignTasksRoute = () => `${getTaskAdminBaseRoute()}/reassigntasks`;
const AdminTaskRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route
            // @ts-expect-error - TS2769 - No overload matches this call.
            , { 
                // @ts-expect-error - TS2769 - No overload matches this call.
                component: TaskTemplateIndex, path: getTaskAdminIndexRoute() }), _jsx(Route, { component: TaskTemplate, path: getTaskAdminTemplateBaseRoute() }), _jsx(Route, { component: ActionPlans, path: getTaskAdminActionPlanBaseRoute() }), _jsx(Route
            // @ts-expect-error - TS2769 - No overload matches this call.
            , { 
                // @ts-expect-error - TS2769 - No overload matches this call.
                component: ReassignTasks, path: getTaskAdminReassignTasksRoute() })] }));
};
export default AdminTaskRoutes;
